import { PreviewMarkdownBaseElement } from './PreviewMarkdownBaseElement';
import { PreviewSnippet, PreviewSnippetProps } from '../code';
import { CodeElementProps } from './types';
import { extractLanguage, isInlineCode } from './utils';

type Props = CodeElementProps & {
  onCopy?: PreviewSnippetProps['onCopy'];
};

export const PreviewMarkdownCodeElement = ({
  children,
  inline,
  node,
  className,
  onCopy,
}: Props) => {
  const codeString = String(children).replace(/\n$/, '');

  if (isInlineCode({ inline, node })) {
    return (
      <PreviewMarkdownBaseElement type="codeInline" as="code">
        {codeString}
      </PreviewMarkdownBaseElement>
    );
  }

  return (
    <PreviewSnippet
      code={codeString}
      language={extractLanguage(className)}
      onCopy={onCopy}
    />
  );
};
